import { BASE_STYLE } from './style';

interface ProfileTitleProps {
    name: string;
    jobTitle: string;
}

/**
 * Renders a team member's name and job title with proper styling and overflow handling
 */
export const ProfileTitle = ({ name, jobTitle }: ProfileTitleProps) => {
    return (
        <div className="w-full">
            <h5
                className={`${BASE_STYLE.TEXT_BASE} my-0 mb-1 font-medium leading-tight`}
            >
                {name}
            </h5>
            <span
                className={`${BASE_STYLE.TEXT_BASE} my-0 block break-words font-normal text-gray-500`}
            >
                {jobTitle}
            </span>
        </div>
    );
};
